import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-loading-spinner-fullscreen',
    templateUrl: './loading-spinner-fullscreen.component.html',
    styleUrls: ['./loading-spinner-fullscreen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingSpinnerFullscreenComponent {

}
